/* eslint-disable no-unused-expressions */
/* eslint-disable import/extensions */
/* eslint-disable react/forbid-prop-types */

import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';

import { Input } from 'components/Input';
import { Button } from 'components/Button';
import { Title, Text } from 'components/Text';

import { StyledDialog, Content } from './styles';

// Modal de Login por link de email
const EmailModal = ({
  open,
  onClose,
  handleUpdate,
}) => {
  const [newEmail, setNewEmail] = useState('');

  useEffect(() => {
    !open && setNewEmail('');
  }, [open]);

  return (
    <StyledDialog
      open={open}
      onClose={onClose}
    >
      <Content>
        <IconButton
          color="secondary"
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
        <Title>Trocar e-mail</Title>
        <Text>
          Para realizar a troca do seu e-mail cadastrado, assim que informar o novo e-mail e confirmar a alteração, você será deslogado da LOIT FGTS e precisará entrar novamente no nosso sistema com o seu novo e-mail.
        </Text>
        <Text style={{ margin: '24px 0 11px 0' }}>
          Digite o novo e-mail no campo abaixo
        </Text>
        <form onSubmit={(ev) => handleUpdate({ ev, newEmail })}>
          <Input
            icon
            required
            name="newEmail"
            type="email"
            value={newEmail}
            onChange={(ev) => setNewEmail(ev.target.value)}
            placeholder="E-mail"
            title="E-mail"
          />
          <Button type="submit">
            Confirmar alteração
          </Button>
        </form>
      </Content>
    </StyledDialog>
  );
};

EmailModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  handleUpdate: PropTypes.func.isRequired,
};

export default EmailModal;
